<template>
    <div class="house-content">
        <ChildPublic v-if="isChild"></ChildPublic>
        <Public v-else-if="!isChild"></Public>
        <div class="house right-content">
            <el-tabs class="house-tab" type="border-card">
                <el-tab-pane label="房源管理">
                </el-tab-pane>
                <div class="house-panel">
                    <div class="house-left">
                        <div class="add-house" @click="addHouseShow">
                            <i class="el-icon-circle-plus-outline"></i>
                            <span>添加房源</span>
                        </div>
                        <div class="house-left-tree">
                            <HouseTree @show="getHouseDevice" ref="houseTree"></HouseTree>
                        </div>
                    </div>
                    <div class="house-mid">
                        <div class="house-addr">
                            <div class="house-addr-content">
                                地址：
                                <span class="house-addr-title">{{addrTitle}}</span>
                            </div>
                        </div>

                        <div class="house-struct-items">
                            <div class="house-struct-item" v-for="(suite, parentIndex) in suites" :key="parentIndex">
                                <div class="suite-title-content">
                                    <div class="suite-title">{{suite.Title}}</div>
                                    <a class="return-table" v-if="isFromTable" @click="returnTable">
                                        返回表格
                                    </a>
                                </div>
                                <div class="house-items">
                                    <div :class="[houseItem, {houseClick: indexPre==-1 && parentIndex==parentIndexPre}]" @click="showHouseData(parentIndex, suite)">
                                        <div class="room-info">
                                            房源总览
                                        </div>
                                        <div class="room-info">
                                            总用电量：{{Number(suite.SumPower).toFixed(2)}}
                                        </div>
                                        <div class="room-info">
                                            总用水量：{{Number(suite.SumWater).toFixed(2)}}
                                        </div>
                                        <div class="room-info">
                                            共计收入：{{Number(suite.SumEarn).toFixed(2)}}
                                        </div>
                                        <div class="room-info">
                                            共计支出：{{Number(suite.SumPay).toFixed(2)}}
                                        </div>
                                    </div>

                                    <div :class="[houseItem, {houseClick: index==indexPre && parentIndex == parentIndexPre}]"
                                         @click="showRoomDetail(index, parentIndex, room)"
                                         v-for="(room, index) in suite.Briefs" :key="index"
                                         @mouseover="showRoomTitle(room)">
                                        <el-tooltip class="item" effect="light" :content="room.Title" placement="top">
                                            <div>
                                                <div class="house-item-shade" v-show="room.Stay == false"></div>
                                                <div class="triangle-in"></div>
                                                <span class="check-status-in" v-if="room.Stay == true"
                                                      @click="checkOut(room.Devid, index, parentIndex)">入住</span>
                                                <span class="check-status-in" v-else
                                                      @click="checkin(room.Devid, room.Price, index, parentIndex)">空置</span>
                                                <div class="room-info">
                                                    房间名称：
                                                    <span class="room-info-title">{{room.Title}}</span>
                                                </div>
                                                <div class="room-info">
                                                    剩余电量：
                                                    <span>{{Number(room.Threshold).toFixed(2)}}</span>
                                                    度
                                                </div>
                                                <div class="room-info">
                                                    电费单价：
                                                    <span>{{Number(room.Price).toFixed(2)}}</span>
                                                    元
                                                </div>
                                                <div class="room-info">
                                                    当前功率：
                                                    <span>{{Number(room.Capacity).toFixed(2)}}</span>
                                                    瓦
                                                </div>
                                            </div>
                                        </el-tooltip>
                                        <div class="icons">
                                            <div class="icons">
                                                <el-tooltip class="item" effect="light" v-if="room.Switch==true" content="操作断电" placement="bottom">
                                                    <i class="iconfont icon-switch-off" @click="offDevice(room.Devid, index, parentIndex)"></i>
                                                </el-tooltip>
                                                <el-tooltip class="item" effect="light" v-else content="操作通电" placement="bottom">
                                                    <i class="iconfont icon-switch-on" @click="onDevice(room.Devid, index, parentIndex)"></i>
                                                </el-tooltip>
                                                <el-tooltip class="item" effect="light" content="充值" placement="bottom">
                                                    <i class="iconfont icon-recharge" @click="recharge(room)"></i>
                                                </el-tooltip>
                                                <el-tooltip class="item" effect="light" v-if="room.Link == true" content="在线" placement="bottom">
                                                <i class="iconfont icon-online" ></i>
                                                </el-tooltip>
                                                <el-tooltip class="item" effect="light" v-else content="离线" placement="bottom">
                                                    <i class="iconfont icon-offline"></i>
                                                </el-tooltip>
                                                <el-tooltip class="item" effect="light" content="用电记录" placement="bottom">
                                                    <i class="iconfont icon-powerecord" @click="powerRecords(room.Devid)"></i>
                                                </el-tooltip>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="load-arrow" @click="loadHouse" v-if="isShowArrow">⬇ 点击下拉</div>

                        </div>
                    </div>
                    <div class="house-right" >
                        <div class="right-room-info" v-show="!isHouse">
                            <div class="info-detail" v-show="!isRoom">
                                <div class="house-info-detail">
                                    <div class="house-info-detail-title">
                                        <div class="dashed">
                                            <div class="dashed-content"></div>
                                        </div>
                                        <div class="dashed-name">房源信息</div>
                                        <div class="dashed">
                                            <div class="dashed-content"></div>
                                        </div>
                                    </div>
                                    <div class="house-info-detail-body">
                                        <div class="house-detail-body-item">
                                            房源套数：{{levelSuite.SumSuite}}
                                        </div>
                                        <div class="house-detail-body-item">
                                            房源间数：{{levelSuite.SumFlat}}
                                        </div>
                                        <div class="house-detail-body-item">
                                            空置间数：{{levelSuite.SumEmptyFlat}}
                                        </div>
                                        <div class="house-detail-body-item">
                                            离线间数：{{levelSuite.SumOfflineFlat}}
                                        </div>
                                        <div class="house-detail-body-item">
                                            欠费间数：{{levelSuite.SumOweFlat}}
                                        </div>
                                    </div>
                                </div>
                                <div class="house-info-detail">
                                    <div class="house-info-detail-title">
                                        <div class="dashed">
                                            <div class="dashed-content"></div>
                                        </div>
                                        <div class="dashed-name">电表信息</div>
                                        <div class="dashed">
                                            <div class="dashed-content"></div>
                                        </div>
                                    </div>
                                    <div class="house-info-detail-body">
                                        <div class="house-detail-body-item">
                                            电表总数：{{levelSuite.SumAmmeter}}
                                        </div>
                                        <div class="house-detail-body-item">
                                            离线电表：{{levelSuite.SumOfflineAmmeter}}
                                        </div>
                                    </div>
                                </div>
                                <div class="house-info-detail">
                                    <div class="house-info-detail-title">
                                        <div class="dashed">
                                            <div class="dashed-content"></div>
                                        </div>
                                        <div class="dashed-name">水表信息</div>
                                        <div class="dashed">
                                            <div class="dashed-content"></div>
                                        </div>
                                    </div>
                                    <div class="house-info-detail-body">
                                        <div class="house-detail-body-item">
                                            水表数量：{{levelSuite.SumFlowmeter}}
                                        </div>
                                        <div class="house-detail-body-item">
                                            离线数量：{{levelSuite.SumOfflineFlowmeter}}
                                        </div>
                                    </div>
                                </div>
                                <div class="house-info-detail">
                                    <div class="house-info-detail-title">
                                        <div class="dashed">
                                            <div class="dashed-content"></div>
                                        </div>
                                        <div class="dashed-name">门锁信息</div>
                                        <div class="dashed">
                                            <div class="dashed-content"></div>
                                        </div>
                                    </div>
                                    <div class="house-info-detail-body">
                                        <div class="house-detail-body-item">
                                            门锁数量：{{levelSuite.SumLock}}
                                        </div>
                                        <div class="house-detail-body-item">
                                            离线数量：{{levelSuite.SumOfflineLock}}
                                        </div>
                                    </div>
                                </div>
                                <div class="house-info-detail house-info-detail-button">
                                    <el-button type="primary" v-if="levelSuite.Level < 0" @click="showDeleteHouseForm(levelSuite.Houseid)">删除房源</el-button>
                                    <!--<el-button type="primary" v-if="levelSuite.Level >= 0" @click="showAddHouseForm(levelSuite)">添加下级房源</el-button>-->
                                    <!--<i class="iconfont icon-checkin" title="办理入住" v-if="room.Stay == false" @click="checkin(roomDetail.Devid, )"></i>-->
                                </div>
                            </div>

                            <div class="room-info" v-show="isRoom">
                                <el-tabs type="border-card">
                                    <el-tab-pane label="房间">
                                        <div class="room-detail-items">
                                            <div id="pay-mode-item" class="room-detail-item">
                                                <span>
                                                    房间名称：
                                                    <span class="room-title-name" v-show="isShowRoomTitle" @click="changeRoomTitle">{{room.Title}}</span>
                                                    <input class="room-title-input" v-show="!isShowRoomTitle" type="text" v-model="room.Title">
                                                </span>
                                                <span>
                                                    <button v-if="isShowRoomTitle" class="room-title-button" @click="changeRoomTitle">修 改</button>
                                                    <button v-else class="room-title-button" @click="confirmChangeRoomTitle(room.Devid, room.Title)">确 定</button>
                                                </span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>使用场景：
                                                    <!--<span v-if="room.Type == 9">个人房间</span>-->
                                                    <!--<span v-else-if="room.Type == 11">独立公共区域</span>-->
                                                    <!--<span v-else>总公共区域</span>-->
                                                </span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>电费单价：{{Number(roomDetail.Price).toFixed(2)}}</span>
                                            </div>
                                            <div id="pay-mode-item" class="room-detail-item">
                                                <span>付费模式：
                                                    <span v-if="roomDetail.PayMode == 0">后付费</span>
                                                    <span v-else>预付费</span>
                                                </span>
                                                <button class="change-mode" @click="changeMode">切换</button>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>剩余电量：{{Number(roomDetail.Threshold).toFixed(2)}}</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>透支电量：{{Number(roomDetail.Excess).toFixed(2)}}</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>房源状态：
                                                    <span v-if="roomDetail.Stay == true">入住</span>
                                                    <span v-if="roomDetail.Stay == false">空置</span>
                                                </span>
                                            </div>
                                            <div class="room-detail-item" v-if="roomDetail.Stay == true">
                                                <span>租客姓名：{{roomDetail.TenantName}}</span>
                                            </div>
                                            <div class="room-detail-item" v-if="roomDetail.Stay == true">
                                                <span>租客电话：{{roomDetail.TenantPhone}}</span>
                                            </div>
                                            <div class="room-detail-item" v-if="roomDetail.Stay == true">
                                                <span>入住时间：{{roomDetail.Checkin}}</span>
                                            </div>
                                            <div class="room-detail-item" v-if="roomDetail.Stay == true">
                                                <span>入住天数：{{roomDetail.StayDays}}</span>
                                            </div>
                                        </div>
                                        <div class="room-detail-icons">
                                            <el-tooltip class="item" effect="dark" v-if="room.Stay == false" content="办理入住" placement="bottom">
                                                <i class="iconfont icon-checkin" @click="checkin(roomDetail.Devid, roomDetail.Price, indexPre, parentIndexPre)"></i>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" v-else content="办理退房" placement="bottom">
                                                <i class="iconfont icon-checkout" @click="checkOut(roomDetail.Devid, indexPre, parentIndexPre)"></i>
                                            </el-tooltip>
                                            <!--<i class="iconfont icon-authorize" title="授权"></i>-->
                                            <el-tooltip class="item" effect="dark" content="充值记录" placement="bottom">
                                                <i class="iconfont icon-rechargeRecord" @click="getRechargeRecords(roomDetail.Devid)"></i>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" content="入住记录" placement="bottom">
                                                <i class="iconfont icon-checkinRecord" @click="getCheckinRecords(roomDetail.Devid)"></i>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" content="操作记录" placement="bottom">
                                                <i class="iconfont icon-opraterecord-copy" @click="getOperateRecords(roomDetail.Devid)"></i>
                                            </el-tooltip>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane label="电表">
                                        <div class="room-detail-items">
                                            <div class="room-detail-item">
                                                <span>电表编号：{{roomDetail.Pcode}}</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>所属网关：{{roomDetail.Ccode}}</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>剩余电量：{{Number(roomDetail.Threshold).toFixed(2)}}度</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>当前度数：{{Number(roomDetail.SumPower).toFixed(2)}}度</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>当前电流：{{Number(roomDetail.Current).toFixed(2)}}A</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>当前电压：{{Number(roomDetail.Voltage).toFixed(2)}}V</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>当前功率：{{Number(roomDetail.Capacity).toFixed(2)}}W</span>
                                            </div>
                                            <div class="room-detail-margin">
                                                <div class="room-detail-item">
                                                    <span>电分摊度数：{{Number(roomDetail.Apportion).toFixed(2)}}度</span>
                                                </div>
                                                <!--<div class="room-detail-item">-->
                                                    <!--<span>水分摊度数：A</span>-->
                                                <!--</div>-->
                                            </div>
                                            <div class="room-detail-item">
                                                <span>更新时间：{{roomDetail.ReportTime}}</span>
                                                <!--<span>更新时间：{{roomDetail.ReportTime.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, "")}}</span>-->
                                            </div>
                                        </div>
                                        <div class="room-detail-icons">
                                            <el-tooltip class="item" effect="dark" v-if="room.Switch==true" content="操作断电" placement="bottom">
                                                <i class="iconfont icon-switch-off" @click="offDevice(roomDetail.Devid)"></i>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" v-else content="操作通电" placement="bottom">
                                                <i class="iconfont icon-switch-on" @click="onDevice(roomDetail.Devid)"></i>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" content="充值" placement="bottom">
                                                <i class="iconfont icon-recharge" @click="recharge(roomDetail)"></i>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" v-if="roomDetail.Link == true" content="在线" placement="bottom">
                                                <i class="iconfont icon-online"></i>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" v-else content="离线" placement="bottom">
                                                <i class="iconfont icon-offline"></i>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" content="用电记录" placement="bottom">
                                                <i class="iconfont icon-powerecord" @click="powerRecords(roomDetail.Devid)"></i>
                                            </el-tooltip>
                                        </div>
                                    </el-tab-pane>

                                    <el-tab-pane label="水表">
                                        <div class="room-detail-items flowe-meter-item" v-for="(flowmeter, index) in roomDetail.Flowmeters">
                                            <div class="room-detail-item">
                                                <span>电表编号：{{flowmeter.Pcode}}</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>所属网关：{{flowmeter.Ccode}}</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>水表名称：{{flowmeter.Title}}</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>水费单价：{{flowmeter.Price}}元</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>总用水量：{{flowmeter.Value}}吨</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span v-if="flowmeter.Link == true">在线情况：在线</span>
                                                <span v-else>在线情况：离线</span>
                                            </div>
                                            <div class="room-detail-item">
                                                <span>更新时间：{{flowmeter.ReportTime}}</span>
                                            </div>
                                        </div>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                        </div>

                        <div class="room-info" v-show="isHouse">
                            <el-tabs type="border-card">
                                <el-tab-pane label="电表">
                                    <div class="room-detail-items">
                                        <div class="room-detail-item">
                                            网关电表：{{suite.GatewayCcode}}
                                        </div>
                                        <div class="room-detail-item">
                                            房间电表：
                                            <span class="room-devices" v-if="briefsLen!= 0">
                                                <i class="iconfont icon-ammeter" v-for="brief in suite.Briefs" @click="showBriefInfo(brief)"></i>
                                            </span>
                                        </div>
                                        <div class="room-detail-item">
                                            总用电量：{{Number(suite.SumPower).toFixed(2)}}
                                        </div>

                                        <div class="room-detail-item" v-if="suite.ApportDev != null">
                                            公摊电量：{{Number(suite.ApportDev.Value).toFixed(2)}}
                                        </div>
                                        <!--<div class="room-detail-item">-->
                                            <!--剩余电量：{{Number(suite.Threshold).toFixed(2)}}-->
                                        <!--</div>-->
                                        <div class="room-detail-item">
                                            欠费房间：-
                                        </div>
                                        <div class="house-expense">
                                            <div class="room-detail-item">
                                                上月收入：{{Number(suite.MonthEarn).toFixed(2)}}
                                            </div>
                                            <div class="room-detail-item">
                                                累计收入：{{Number(suite.SumEarn).toFixed(2)}}
                                            </div>
                                        </div>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="门锁">
                                    <div class="room-detail-items">
                                        <div class="room-detail-item">
                                            门锁名称：{{suite.LockPcode}}
                                        </div>
                                        <div class="room-detail-item">
                                            电池电量：{{suite.LockBattary}}
                                        </div>
                                        <div class="room-detail-item" v-if="suite.LockLink == true">
                                            在线情况：在线
                                        </div>
                                        <div class="room-detail-item" v-else>
                                            在线情况：离线
                                        </div>
                                        <div class="room-detail-item">
                                            电池电量：{{suite.LockBattary}}
                                        </div>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="水表">
                                    <div class="room-detail-items flowe-meter-item" v-for="(ApportFlowmeter, index) in suite.ApportFlowmeters">
                                        <div class="room-detail-item">
                                            <span>电表编号：{{ApportFlowmeter.Pcode}}</span>
                                        </div>
                                        <div class="room-detail-item">
                                            <span>所属网关：{{ApportFlowmeter.Ccode}}</span>
                                        </div>
                                        <div class="room-detail-item">
                                            <span>水表名称：{{ApportFlowmeter.Title}}</span>
                                        </div>
                                        <div class="room-detail-item">
                                            <span>水费单价：{{ApportFlowmeter.Price}}元</span>
                                        </div>
                                        <div class="room-detail-item">
                                            <span>总用水量：{{ApportFlowmeter.Value}}吨</span>
                                        </div>
                                        <div class="room-detail-item">
                                            <span v-if="ApportFlowmeter.Link == true">在线情况：在线</span>
                                            <span v-else>在线情况：离线</span>
                                        </div>
                                        <div class="room-detail-item">
                                            <span>更新时间：{{ApportFlowmeter.ReportTime}}</span>
                                        </div>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </div>
            </el-tabs>
        </div>
        <el-dialog
                title="断电操作"
                :visible.sync="offDiviceVisible"
                width="5rem"
        >
            <span>您当前正在进行断电！是否确认立即断电？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="offDiviceVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmOffDevice">确 定({{offCount}})</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="通电操作"
                :visible.sync="onDiviceVisible"
                width="5rem"
        >
            <span>您当前正在进行通电！是否确认立即通电？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="onDiviceVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmOnDevice">确 定({{onCount}})</el-button>
            </span>
        </el-dialog>
        <!--添加房源-->
        <el-dialog
                title="添加房源"
                :visible.sync="addHouseVisible"
                width="6rem">
            <div class="add-house-content">
                <el-form>
                    <el-form-item>
                        <div class="add-house-item">
                            <div class="add-house-select-title">所在区域</div>
                            <el-select class="add-house-select" v-model="province" placeholder="请选择省份"  @change="selectProvince">
                                <el-option v-for="(city0, city0Index) in citys0" :label="city0.Title" :value="city0.Code" :key="city0Index"></el-option>
                            </el-select>
                            <el-select class="add-house-select" v-model="city" placeholder="请选择城市" @change="selectCity">
                                <el-option  v-for="(city1, city1Index) in citys1" :label="city1.Title" :value="city1.Code" :key="city1Index"></el-option>
                            </el-select>
                            <el-select class="add-house-select" v-model="district" placeholder="请选择区/县" @change="selectDistrict">
                                <el-option  v-for="(city2, city2Index) in citys2" :label="city2.Title" :value="city2.Code" :key="city2Index"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="add-house-item">
                            <div class="add-house-select-title">所在小区</div>
                            <el-select class="add-house-button-select" v-model="communityName" filterable placeholder="请输入选择或添加小区" @change="selectCommunity">
                                <el-option  v-for="(city3, city3Index) in citys3" :label="city3.Title" :value="city3.Code" :key="city3Index"></el-option>
                            </el-select>
                            <el-button class="add-house-button" @click="showCommunityForm" type="primary">创建小区</el-button>
                        </div>
                    </el-form-item>
                    <div class="create_community_form" v-show="isShowCommunityForm">
                        <div class="add-house-item">
                            <div class="add-house-select-title">小区名称</div>
                            <el-input class="create_community_form_input" v-model="communityName" placeholder="请输入小区名"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">小区描述</div>
                            <el-input class="create_community_form_input" v-model="communityDesc" placeholder="请输入小区描述"></el-input>
                        </div>
                        <div class="button-center">
                            <el-button class="create_community_form_button" @click="createCommunity(selectedDistrict)" type="primary">确认提交</el-button>
                        </div>
                    </div>

                    <el-form-item>
                        <div class="add-house-item">
                            <div class="add-house-select-title">一级分组</div>
                            <el-select class="add-house-button-select" v-model="community" filterable placeholder="请选择或添加一级分组" @change="selectLevel1House">
                                <el-option v-for="(level1House, level1HouseIndex) in level1Houses" :label="level1House.Title" :value="level1House.Code" :key="level1HouseIndex"></el-option>
                            </el-select>
                            <el-button class="add-house-button" @click="showLevel1HouseForm" type="primary">创建分组</el-button>
                        </div>
                    </el-form-item>
                    <div class="create_community_form" v-show="isShowLevel1HouseForm">
                        <div class="add-house-item">
                            <div class="add-house-select-title">分组名称</div>
                            <el-input class="create_community_form_input" v-model="level1HouseTitle" placeholder="请输入分组名称"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">电表底数</div>
                            <el-input class="create_community_form_input" v-model="baseno" placeholder="请输入电表底数"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">电表户号</div>
                            <el-input class="create_community_form_input" v-model="ammeterno" placeholder="请输入电表户号"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">付费类型</div>
                            <el-select class="create_community_form_input" v-model="modeValue" placeholder="请选择" @change="selectMode">
                                <el-option
                                    label="国网预付费"
                                    value=0>
                                </el-option>
                                <el-option
                                    label="国网后付费"
                                    value=1>
                                </el-option>
                            </el-select>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">付费类型</div>
                            <el-select class="create_community_form_input" v-model="alarmValue" placeholder="请选择" @change="selectAlarmVal">
                                <el-option
                                        label="预警度数为10度"
                                        value="10">
                                </el-option>
                                <el-option
                                        label="预警度数为20度"
                                        value="20">
                                </el-option>
                                <el-option
                                        label="预警度数为30度"
                                        value="30">
                                </el-option>
                                <el-option
                                        label="预警度数为40度"
                                        value="40">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="button-center">
                            <el-button class="create_community_form_button" @click="createHouseLevel1(communityCode)" type="primary">确认提交</el-button>
                        </div>
                    </div>

                    <el-form-item>
                        <div class="add-house-item">
                            <div class="add-house-select-title">二级分组</div>
                            <el-select class="add-house-button-select" v-model="level2HouseTitle" filterable placeholder="请选择或添加二级分组" @change="selectLevel2House">
                                <el-option v-for="(level2House, level2HouseIndex) in level2Houses" :label="level2House.Title" :value="level2House.Code" :key="level2HouseIndex"></el-option>
                            </el-select>
                            <el-button class="add-house-button" @click="showLevel2HouseForm" type="primary">创建分组</el-button>
                        </div>
                    </el-form-item>
                    <div class="create_community_form" v-show="isShowLevel2HouseForm">
                        <div class="add-house-item">
                            <div class="add-house-select-title">分组名称</div>
                            <el-input class="create_community_form_input" v-model="level2HouseTitle" placeholder="请输入分组名称"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">电表底数</div>
                            <el-input class="create_community_form_input" v-model="level2Baseno" placeholder="请输入电表底数"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">电表户号</div>
                            <el-input class="create_community_form_input" v-model="level2Ammeterno" placeholder="请输入电表户号"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">付费模式</div>
                            <el-select class="create_community_form_input" v-model="level2ModeValue" placeholder="请选择" @change="selectMode">
                                <el-option
                                        label="国网预付费"
                                        value=0>
                                </el-option>
                                <el-option
                                        label="国网后付费"
                                        value=1>
                                </el-option>
                            </el-select>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">预警度数</div>
                            <el-select class="create_community_form_input" v-model="level2AlarmValue" placeholder="请选择" @change="selectAlarmVal">
                                <el-option
                                        label="预警度数为10度"
                                        value="10">
                                </el-option>
                                <el-option
                                        label="预警度数为20度"
                                        value="20">
                                </el-option>
                                <el-option
                                        label="预警度数为30度"
                                        value="30">
                                </el-option>
                                <el-option
                                        label="预警度数为40度"
                                        value="40">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="button-center">
                            <el-button class="create_community_form_button" @click="createHouseLevel2()" type="primary">确认提交</el-button>
                        </div>
                    </div>

                    <el-form-item>
                        <div class="add-house-item">
                            <div class="add-house-select-title">房源地址</div>
                            <el-select class="add-house-button-select" v-model="level2HouseTitle" placeholder="请添加房源">
                                <!--<el-option v-for="(level2House, level2HouseIndex) in level2Houses" :label="level2House.Title" :value="level2House.Code" :key="level2HouseIndex"></el-option>-->
                            </el-select>
                            <el-button class="add-house-button" @click="showHouseForm" type="primary">创建房源</el-button>
                        </div>
                    </el-form-item>
                    <div class="create_community_form" v-show="isShowHouseForm">
                        <div class="add-house-item">
                            <div class="add-house-select-title">房源名称</div>
                            <el-input class="create_community_form_input" v-model="houseTitle" placeholder="请输入房源名称"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">电表底数</div>
                            <el-input class="create_community_form_input" v-model="houseBaseno" placeholder="请输入电表底数"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">电表户号</div>
                            <el-input class="create_community_form_input" v-model="houseAmmeterno" placeholder="请输入电表户号"></el-input>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">付费模式</div>
                            <el-select class="create_community_form_input" v-model="level2ModeValue" placeholder="请选择" @change="selectMode">
                                <el-option
                                        label="国网预付费"
                                        value=0>
                                </el-option>
                                <el-option
                                        label="国网后付费"
                                        value=1>
                                </el-option>
                            </el-select>
                        </div>
                        <div class="add-house-item">
                            <div class="add-house-select-title">预警度数</div>
                            <el-select class="create_community_form_input" v-model="level2AlarmValue" placeholder="请选择" @change="selectAlarmVal">
                                <el-option
                                        label="预警度数为10度"
                                        value="10">
                                </el-option>
                                <el-option
                                        label="预警度数为20度"
                                        value="20">
                                </el-option>
                                <el-option
                                        label="预警度数为30度"
                                        value="30">
                                </el-option>
                                <el-option
                                        label="预警度数为40度"
                                        value="40">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="button-center">
                            <el-button class="create_community_form_button" @click="createHouse()" type="primary">确认提交</el-button>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addHouseVisible = false">取 消</el-button>
                <!--<el-button type="primary" @click="addHouseVisible = false">确 定</el-button>-->
            </span>
        </el-dialog>

        <el-dialog
                title="入住"
                :visible.sync="checkinVisible"
                width="5rem"
        >
            <div class="checkin-content">
                <div class="checkin-item">
                    租客姓名：
                    <el-input
                            class="checkin-input"
                            placeholder="请输入租客姓名"
                            v-model="renterName"
                            clearable>
                    </el-input>
                </div>
                <div class="checkin-item">
                    租客电话：
                    <el-input
                            class="checkin-input"
                            placeholder="请输入租客手机号"
                            v-model="renterPhone"
                            clearable>
                    </el-input>
                </div>
                <div class="checkin-item">
                    房间电价：
                    <el-input
                            class="checkin-input"
                            placeholder="请输入房间电费单价"
                            v-model="renterPrice"
                            clearable>
                    </el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="checkinVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmCheckin">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
                class="power-records"
                title="用电记录"
                :visible.sync="powerRecordsVisible"
                width="5rem"
        >
            <div class="power-records-content">
                <div class="checkin-records-block">
                    <div class="block">
                        <el-date-picker
                                class="date-picker"
                                v-model="powerRecordsValue1"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="changePowerRecordsDate"
                        >
                        </el-date-picker>
                        <el-date-picker
                                class="date-picker"
                                v-model="powerRecordsValue2"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="changePowerRecordsDate"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <el-table
                        :data="powerRecordsArr"
                        style="width: 100%"
                        max-height="350">
                    <el-table-column
                            prop="date"
                            label="日期">
                    </el-table-column>
                    <el-table-column
                            prop="power"
                            label="电量">
                    </el-table-column>
                    <el-table-column
                            prop="apportion"
                            label="公摊">
                    </el-table-column>
                </el-table>
                <div class="power-statistic">
                    <div class="day-power-statistic">
                        用电统计：<span class="statistic-title">{{allPower.toFixed(2)}}</span>
                    </div>
                    <div class="apportion-statistic">
                        公摊统计：<span class="statistic-title">{{allApportion.toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="powerRecordsVisible = false">取 消</el-button>
                <el-button type="primary" @click="downloadPowerRecords">导出表格</el-button>
            </span>
        </el-dialog>

        <el-dialog
                title="充值记录"
                :visible.sync="rechargeRecordsVisible"
                width="5rem"
        >
            <div class="power-records-content">
                <div class="checkin-records-block">
                    <div class="block">
                        <el-date-picker
                                class="date-picker"
                                v-model="rechargeRecordsValue1"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="changeRechargeRecords"
                        >
                        </el-date-picker>
                        <el-date-picker
                                class="date-picker"
                                v-model="rechargeRecordsValue2"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="changeRechargeRecords"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <el-table
                        :data="rechargeRecords"
                        style="width: 100%"
                        max-height="350">
                    <el-table-column
                            prop="date"
                            label="日期">
                    </el-table-column>
                    <el-table-column
                            prop="money"
                            label="金额">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="姓名">
                    </el-table-column>
                    <el-table-column
                            prop="phone"
                            label="电话">
                    </el-table-column>
                    <el-table-column
                            prop="rechargeway"
                            label="方式">
                    </el-table-column>
                    <el-table-column
                            prop="cause"
                            label="备注">
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="rechargeRecordsVisible = false">取 消</el-button>
                <el-button type="primary" @click="downloadPowerRecords">导出表格</el-button>
            </span>
        </el-dialog>

        <el-dialog
                class="checkin-records"
                title="入住记录"
                :visible.sync="checkinRecordsVisible"
                width="5rem"
                v-if="checkinRecords.length == 0"
                style="height:35vh !important"
        >
            <div class="checkin-records-content">
                <div class="checkin-records-block">
                    <div class="block">
                        <el-date-picker
                                class="date-picker"
                                v-model="checkinRecordsValue1"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="changeCheckinRecords"
                        >
                        </el-date-picker>
                        <el-date-picker
                                class="date-picker"
                                v-model="checkinRecordsValue2"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="changeCheckinRecords"
                                >
                        </el-date-picker>
                    </div>
                </div>
                <div class="checkin-records-item" v-if="checkinRecords.length == 0">
                    无数据
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="checkinRecordsVisible = false">取 消</el-button>
                <el-button type="primary" @click="downloadCheckinRecords">导出表格</el-button>
            </span>
        </el-dialog>
        <el-dialog
                class="checkin-records"
                title="入住记录"
                :visible.sync="checkinRecordsVisible"
                width="5rem"
                v-else
        >
            <div class="checkin-records-content">
                <div class="checkin-records-block">
                    <div class="block">
                        <el-date-picker
                                class="date-picker"
                                v-model="checkinRecordsValue1"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="changeCheckinRecords"
                        >
                        </el-date-picker>
                        <el-date-picker
                                class="date-picker"
                                v-model="checkinRecordsValue2"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="changeCheckinRecords"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div class="checkin-records-item" v-for="checkinRecord in checkinRecords">
                    <div class="checkin-records-item-row">
                        <div class="checkin-row-left" v-if="checkinRecord.Expand != null">入住日期：{{checkinRecord.Expand.checkindate}}</div>
                        <div class="checkin-row-left" v-else>退房日期：{{checkinRecord.Addtime.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, "").replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/,"")}}</div>
                        <div class="checkin-row-right" v-if="checkinRecord.Expand != null">租客：{{checkinRecord.Expand.name}}</div>
                    </div>
                    <div class="checkin-records-item-row">
                        <div class="checkin-row-left">初始电量：{{checkinRecord.Initpower.toFixed(2)}}</div>
                        <div class="checkin-row-right">退房电量：{{checkinRecord.Lastpower.toFixed(2)}}</div>
                    </div>
                    <div class="checkin-records-item-row">
                        <div class="checkin-row-left">总耗电量：{{checkinRecord.Allpower.toFixed(2)}}</div>
                        <div class="checkin-row-right">分摊电量：{{checkinRecord.Apportion.toFixed(2)}}</div>
                    </div>
                    <div class="checkin-records-item-row">
                        <div class="checkin-row-left">计费电量：{{checkinRecord.Allpower.toFixed(2)}}</div>
                        <div class="checkin-row-right">电费单价：{{checkinRecord.Price}}</div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="checkinRecordsVisible = false">取 消</el-button>
                <el-button type="primary" @click="downloadCheckinRecords">导出表格</el-button>
            </span>
        </el-dialog>

        <el-dialog
                class="operate-records-dialog"
                title="操作记录"
                :visible.sync="oprateRecordsVisible"
                width="5rem"
                v-if="oprateRecords.length == 0"
                style="height:35vh !important"
        >
            <div class="checkin-records-content">
                <div class="checkin-records-item">
                    无数据
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="oprateRecordsVisible = false">取 消</el-button>
                <el-button type="primary" @click="downloadOprateRecords">导出表格</el-button>
            </span>
        </el-dialog>
        <el-dialog
                class="operate-records-dialog"
                title="操作记录"
                :visible.sync="oprateRecordsVisible"
                width="5rem"
                v-else
        >
            <div class="checkin-records-content">
                <div class="checkin-records-item" v-for="oprateRecord in oprateRecords">
                    <div class="oprate-records-item-row">
                        <div>{{oprateRecord.Content}}</div>
                        <div>{{oprateRecord.Addtime.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, "")}}</div>
                    </div>
                </div>
                <div class="load-arrow" @click="loadOprateRecord" v-if="isShowOprateArrow">⬇ 点击下拉</div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="oprateRecordsVisible = false">取 消</el-button>
                <el-button type="primary" @click="downloadOprateRecords">导出表格</el-button>
            </span>
        </el-dialog>

        <el-dialog
                class="records-dialog"
                title="删除房源"
                :visible.sync="deleteHouseVisible"
                width="5rem"
        >
            <div class="checkin-records-content">
                您正在删除房源！是否确认删除该房源？
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteHouseVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteHouse()">确认</el-button>
            </span>
        </el-dialog>

        <el-dialog
                class="records-dialog"
                title="切换付费模式"
                :visible.sync="changeModeVisible"
                width="5rem"
        >
            <div class="checkin-records-content">
                您正在切换付费模式！是否确认修改？
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="changeModeVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmChangeMode()">确认</el-button>
            </span>
        </el-dialog>

        <el-dialog
                class="records-dialog"
                title="充值"
                :visible.sync="rechargeVisible"
                width="30%"
        >
            <div class="checkin-records-content">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="当前单价" class="recharge-money">
                        {{room.Price}}元
                    </el-form-item>
                    <el-form-item label="充值金额" class="recharge-money">
                        <el-input v-model="form.money" placeholder="请输入充值金额(元)"></el-input>
                    </el-form-item>
                    <div class="recharge-num">充值度数：{{(form.money / room.Price).toFixed(2)}}</div>
                    <el-form-item label="充值原因">
                        <el-input type="textarea" v-model="form.reason"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="rechargeVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmRecharge()">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import store from "../store";
    import Public from '@/views/Public.vue'
    import ChildPublic from '@/views/ChildPublic.vue'

    import HouseTree from '@/components/HouseTree.vue'
    import Checkout from '@/components/Checkout.vue'
    import Recharge from '@/components/Recharge.vue'
    var FileSaver = require('file-saver');
    let _this = {}

    export default {
        name: "HouseManage",
        components: {
            Public,
            HouseTree,
            Checkout,
            Recharge,
            ChildPublic,
        },
        data() {
            return {
                zone: {},
                suites: [],
                room: {},
                isRoom: false,
                houseItem: 'house-item',
                indexPre: -1,
                parentIndexPre: -1,
                roomTitle: '',
                isHouse: false,
                suite: {},
                levelSuite: {},
                roomDetail: {},
                addrTitle: '',
                showAccount: false,
                briefsLen: 0,
                offDiviceVisible: false,
                offCount: 0,
                onDiviceVisible: false,
                onCount: 0,
                childItems: [],
                addHouseVisible: false,
                isShowRoomTitle: true,
                formLabelWidth: '10%',
                clickIndex: 1,
                renterName: '',
                renterPhone: '',
                renterPrice: '',
                checkinVisible: false,
                powerRecordsVisible: false,
                powerRecordsBdate: '',
                powerRecordsEdate: '',
                powerRecordsArr: [],
                powerRecordsValue1: '',
                powerRecordsValue2: '',
                allPower: 0,
                allApportion: 0,

                rechargeRecordsVisible: false,
                rechargeRecords: [],
                rechargeRecordsValue1: '',
                rechargeRecordsValue2: '',

                checkinRecordsVisible: false,
                checkinRecordsBdate: '',
                checkinRecordsEdate: '',
                checkinRecords: [],
                checkinRecord: {},
                addtime: '',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                checkinRecordsValue1: '',
                checkinRecordsValue2: '',
                citys0: [],
                citys1: [],
                citys2: [],
                citys3: [],
                level1Houses: [],
                level2Houses: [],
                province: '',
                city: '',
                district: '',
                community: '',
                communityName: '',
                communityDesc: '',
                selectedDistrict: '',
                communityCode: '',
                oprateRecordsVisible: false,
                oprateRecordsValue1: '',
                oprateRecordsValue2: '',
                oprateRecords: [],
                isShowCommunityForm: false,
                isShowLevel1HouseForm: false,
                isShowLevel2HouseForm: false,
                isShowHouseForm: false,

                level1HouseTitle: '',
                baseno: 0.0,
                ammeterno: '',
                modeValue: 1,
                alarmValue: 10,

                level1DistrictCode: '',
                level1Code: '',
                level2HouseTitle: '',
                level2Baseno: 0.0,
                level2Ammeterno: '',
                level2ModeValue: 1,
                level2AlarmValue: 10,

                houseTitle: '',
                houseBaseno: 0.0,
                houseAmmeterno: '',
                houseModeValue: 1,
                houseAlarmValue: 0,
                level2DistrictCode: '',
                level2Code: '',
                houseCode: '',

                deleteHouseVisible: false,
                isChild: false ,
                oprateRecordIndex: 0,
                houseSkip: 10,
                isShowArrow: false,
                isShowOprateArrow: false,
                changeModeVisible: false,
                rechargeVisible: false,
                form: {
                    money: 0,
                    reason: '',
                },
                isFromTable: false,
            }
        },
        mounted() {
            if (window.localStorage.isChild == 0) {
                this.isChild = false;
                store.commit('assigntreeZoneid', '');
                console.log('flsjdfkjds')
                if (window.localStorage.sid != '') {
                    this.$http.get(`${store.state.url}zone/suitelocate/${window.localStorage.sid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.isFromTable = true;
                                this.addrTitle = res.Data.Address;
                                this.zone = res.Data;
                                this.suites = res.Data.SuiteView;
                                this.levelSuite = res.Data;
                                store.commit('assigntreeZoneid', res.Data.Uuid);
                            } else {
                                this.$message(res.Message);
                            }
                        });
                    window.localStorage.sid = '';
                } else if (window.localStorage.devid != '' && window.localStorage.sid == '') {
                    this.$http.get(`${store.state.url}zone/devicelocate/${window.localStorage.devid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.isFromTable = true;
                                this.addrTitle = res.Data.Address;
                                this.zone = res.Data;
                                this.suites = res.Data.SuiteView;
                                this.levelSuite = res.Data;
                                store.commit('assigntreeZoneid', res.Data.Uuid);
                            } else {
                                this.$message(res.Message);
                            }
                        });
                    window.localStorage.devid = '';
                } else {
                    this.$http.get(`${store.state.url}zone/top?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.zone = res.Data;
                                this.suites = res.Data.SuiteView;
                                this.levelSuite = res.Data;

                                if (this.levelSuite.SumSuite <= this.suites.length) {
                                    this.isShowArrow = false;
                                } else {
                                    this.isShowArrow = true;
                                }
                            } else {
                                this.$message(res.Message);
                            }
                        });
                }
            } else {
                this.isChild = true;
                store.commit('assigntreeZoneid', '');
                console.log('flsjdfkjds')
                if (window.localStorage.sid != '') {
                    this.$http.get(`${store.state.url}zone/suitelocate/${window.localStorage.sid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.isFromTable = true;
                                this.addrTitle = res.Data.Address;
                                this.zone = res.Data;
                                this.suites = res.Data.SuiteView;
                                this.levelSuite = res.Data;
                                store.commit('assigntreeZoneid', res.Data.Uuid);
                            } else {
                                this.$message(res.Message);
                            }
                        });
                    window.localStorage.sid = '';
                } else if (window.localStorage.devid != '' && window.localStorage.sid == '') {
                    this.$http.get(`${store.state.url}zone/devicelocate/${window.localStorage.devid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.isFromTable = true;
                                this.addrTitle = res.Data.Address;
                                this.zone = res.Data;
                                this.suites = res.Data.SuiteView;
                                this.levelSuite = res.Data;
                                store.commit('assigntreeZoneid', res.Data.Uuid);
                            } else {
                                this.$message(res.Message);
                            }
                        });
                    window.localStorage.devid = '';
                } else {
                    this.$http.get(`${store.state.url}zone/top?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.zone = res.Data;
                                this.suites = res.Data.SuiteView;
                                this.levelSuite = res.Data;

                                if (this.levelSuite.SumSuite <= this.suites.length) {
                                    this.isShowArrow = false;
                                } else {
                                    this.isShowArrow = true;
                                }
                            } else {
                                this.$message(res.Message);
                            }
                        });
                }
            }
        },
        methods: {
            getHouseDevice(){
                this.houseSkip = 10;
                this.isFromTable = false,
                this.$http.get(`${store.state.url}zone/id/${store.state.zoneid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.isHouse = false;
                            this.isRoom = false;
                            this.addrTitle = res.Data.Address;
                            this.zone = res.Data;
                            this.suites = res.Data.SuiteView;
                            this.levelSuite = res.Data;

                            if (this.levelSuite.SumSuite <= this.suites.length) {
                                this.isShowArrow = false;
                            } else {
                                this.isShowArrow = true;
                            }
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            addHouseShow() {
                this.addHouseVisible = true;
                this.$http.get(`${store.state.url}house/city/0?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.citys0 = res.Data;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            selectProvince(code) {
                this.$http.get(`${store.state.url}house/city/1/${code}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.citys1 = res.Data;
                            this.city = "";
                            this.district = "";
                            this.community = "";
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            selectCity(code) {
                this.$http.get(`${store.state.url}house/city/2/${code}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.citys2 = res.Data;
                            this.district = "";
                            this.community = "";
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            selectDistrict(code) {
                this.$http.get(`${store.state.url}house/city/3/${code}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.citys3 = res.Data;
                            this.community = "";
                            this.selectedDistrict = code;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            createCommunity(code) {
                this.$http({
                    method: 'post',
                    url: `${store.state.url}house/district?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: {
                        Code: code,
                        Title: this.communityName,
                        Content: this.communityDesc,
                    }
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.$message('添加成功');
                            this.communityCode = res.Data.Code;
                            this.isShowCommunityForm = !this.isShowCommunityForm;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            createHouseLevel1(code) {
                this.$http({
                    method: 'post',
                    url: `${store.state.url}house?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: {
                        "districtcode": code,
                        "title": this.level1HouseTitle,
                        "level": 0,
                        "structure": 0,
                        "leasetype": 0,
                        "acreage": 0,
                        "phone": "",
                        "contact": "",
                        "househost": "",
                        "ammeterinc": "",
                        "ammeterno": this.ammeterno,
                        "StateGridAlarmMode": this.modeValue,
                        "StateGridAlarmValue":{"alarmvalue":this.alarmValue},
                        "meter": this.baseno,
                    }
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.$message('添加成功');
                            this.level1DistrictCode = res.Data.Districtcode;
                            this.level1Code = res.Data.Code;
                            this.houseCode = res.Data.Code;
                            let houseid = res.Data.Uuid;
                            this.$http.get(`${store.state.url}zone/addhouse/${houseid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                                .then((res) => {
                                    if (res.Code == 0) {
                                        this.$refs.houseTree.createTree()
                                    } else {
                                        this.$message(res.Message);
                                    }
                                })
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            createHouseLevel2() {
                this.$http({
                    method: 'post',
                    url: `${store.state.url}/house?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: {
                        "districtcode": this.level1DistrictCode,
                        "title": this.level2HouseTitle,
                        "level": 1,
                        "code": this.level1Code,
                        "structure": 0,
                        "leasetype": 0,
                        "acreage": 0,
                        "phone": "",
                        "contact": "",
                        "househost": "",
                        "ammeterinc": "",
                        "ammeterno": this.level2Ammeterno,
                        "StateGridAlarmMode": this.level2ModeValue,
                        "StateGridAlarmValue":{"alarmvalue":this.level2AlarmValue},
                        "meter": this.level2Baseno,
                    }
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.$message('添加成功');
                            this.level2DistrictCode = res.Data.Districtcode;
                            this.level2Code = res.Data.Code;
                            this.houseCode = res.Data.Code;
                            let houseid = res.Data.Uuid;
                            this.$http.get(`${store.state.url}zone/addhouse/${houseid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                                .then((res) => {
                                    if (res.Code == 0) {
                                        this.$refs.houseTree.createTree()
                                    } else {
                                        this.$message(res.Message);
                                    }
                                })
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            createHouse() {
                this.$http({
                    method: 'post',
                    url: `${store.state.url}house?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: {
                        "districtcode": this.communityCode,
                        "title": this.houseTitle,
                        "level": 2,
                        "code": this.houseCode,
                        "structure": 0,
                        "leasetype": 0,
                        "acreage": 0,
                        "phone": "",
                        "contact": "",
                        "househost": "",
                        "ammeterinc": "",
                        "ammeterno": this.houseAmmeterno,
                        "StateGridAlarmMode": this.houseModeValue,
                        "StateGridAlarmValue":{"alarmvalue":this.houseAlarmValue},
                        "meter": this.houseBaseno
                    }
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.$message('添加成功');
                            let houseid = res.Data.Uuid;
                            this.$http.get(`${store.state.url}zone/addhouse/${houseid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                                .then((res) => {
                                    if (res.Code == 0) {
                                        this.$refs.houseTree.createTree()
                                    } else {
                                        this.$message(res.Message);
                                    }
                                })
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            showDeleteHouseForm(hid) {
                store.commit('assignDeleteHid', hid);
                this.deleteHouseVisible = true;
            },
            deleteHouse() {
                this.deleteHouseVisible = false;
                this.$http({
                    method: 'delete',
                    url: `${store.state.url}house/${store.state.deleteHid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            if (res.Code == 0) {
                                this.$message('删除成功');
                                this.$http.get(`${store.state.url}zone/delhouse/${store.state.deleteHid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                                    .then((res) => {
                                        if (res.Code == 0) {
                                            this.$refs.houseTree.createTree()
                                        } else {
                                            this.$message(res.Message);
                                        }
                                    })
                            } else {
                                this.$message(res.Message);
                            }
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            showRoomDetail(index, parentIndex, room) {
                this.isShowRoomTitle = true;
                this.isHouse = false;
                this.room = room;
                this.isRoom =  true;
                this.indexPre = index;
                this.parentIndexPre = parentIndex;

                this.$http.get(`${store.state.url}zone/flat/id/${room.FlatID}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.roomDetail = res.Data;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            showRoomTitle(room) {
                this.roomTitle = room.Title;
            },
            showHouseData(parentIndex, suite) {
                this.suite = suite;
                this.briefsLen = this.suite.Briefs.length
                this.isHouse = true;
                this.indexPre = -1;
                this.parentIndexPre = parentIndex;
                this.suite.Threshold = this.suite.Threshold;
            },
            onDevice(devid, index, parentIndex) {
                store.commit('assignClickDevid', devid);
                store.commit('assignClickIndex', index);
                store.commit('assignClickParentIndex', parentIndex);
                this.onDiviceVisible = true;
            },
            confirmOnDevice() {
                this.onCount++;
                if (this.onCount == 2) {
                    this.onDiviceVisible = false;
                    this.$http({
                        method: 'put',
                        url: `${store.state.url}device/switchon/${store.state.clickDevid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    })
                        .then((res) => {
                            if (res.Code == 0) {
                                this.$message(res.Message);
                                this.onCount = 0;
                                this.$http({
                                    method: 'get',
                                    url: `${store.state.url}zone/freshensuite/${store.state.clickDevid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                                })
                                    .then((res) => {
                                        if (res.Code == 0) {
                                            this.suites[store.state.clickParentIndex].Briefs[store.state.clickIndex].Switch = true;
                                        } else {
                                            this.$message(res.Message);
                                        }
                                    })
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }
            },
            offDevice(devid, index, parentIndex) {
                console.log(index)
                store.commit('assignClickDevid', devid);
                store.commit('assignClickIndex', index);
                store.commit('assignClickParentIndex', parentIndex);
                this.offDiviceVisible = true;
            },
            confirmOffDevice() {
                this.offCount++;
                if (this.offCount == 2) {
                    this.offDiviceVisible = false;
                    this.$http({
                        method: 'put',
                        url: `${store.state.url}device/switchoff/${store.state.clickDevid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    })
                        .then((res) => {
                            if (res.Code == 0) {
                                this.$message(res.Message);
                                this.offCount = 0;
                                this.$http({
                                    method: 'get',
                                    url: `${store.state.url}zone/freshensuite/${store.state.clickDevid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                                })
                                    .then((res) => {
                                        if (res.Code == 0) {
                                            console.log(res)
                                            this.suites[store.state.clickParentIndex].Briefs[store.state.clickIndex].Switch = false;
                                            this.roomDetail.Switch = false;
                                        } else {
                                            this.$message(res.Message);
                                        }
                                    })
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }
            },
            recharge(device) {
                store.commit('getRechargeDevice', device)
                this.rechargeVisible = true;
                this.form.reason = '';
                this.form.money = 0;
            },
            confirmRecharge() {
                let value = this.form.money,
                    reason = this.form.reason;
                this.$http({
                    method: 'put',
                    url: `${store.state.url}account/recharge/${store.state.rechargeDevice.Devid}/${value}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: reason
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.rechargeVisible = false;
                            this.$message('充值成功');
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            checkin(devid, price, index, parentIndex) {
                store.commit('assignClickIndex', index);
                store.commit('assignClickParentIndex', parentIndex);
                this.checkinVisible = true;
                store.commit('assignClickDevid', devid);
                this.renterPrice = price;
            },
            confirmCheckin() {
                this.$http({
                    method: 'put',
                    url: `${store.state.url}device/ammeter/stayroom/${store.state.clickDevid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: {
                        name: this.renterName,
                        phone: this.renterPhone,
                        price: this.renterPrice,
                    }
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.checkinVisible = false;
                            this.$http({
                                method: 'get',
                                url: `${store.state.url}zone/freshensuite/${store.state.clickDevid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                            })
                                .then((res) => {
                                    if (res.Code == 0) {
                                        this.suites[store.state.clickParentIndex].Briefs[store.state.clickIndex].Stay = true;
                                        this.roomDetail.Stay = true;
                                        this.$message('已成功入住');
                                    } else {
                                        this.$message(res.Message);
                                    }
                                })
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            checkOut(devid, index, parentIndex) {
                this.$http({
                    method: 'put',
                    url: `${store.state.url}device/ammeter/recederoom/` + devid + '?uid=' + window.localStorage.uid + '&token=' + window.localStorage.token ,
                })
                    .then((res) => {
                        store.commit('assignRecedeData', res.Data);
                        let el = this.$createElement;
                        this.$msgbox({
                            title: '房间退房',
                            message: el('Checkout'),
                            showCancelButton: true,
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                        })
                            .then(() => {
                                if (res.Code == 0) {
                                    this.$http({
                                        method: 'put',
                                        url: `${store.state.url}device/ammeter/confirmrecederoom/${devid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                                    })
                                        .then((res) => {
                                            if (res.Code == 0) {
                                                this.checkinVisible = false;
                                                this.$http({
                                                    method: 'get',
                                                    url: `${store.state.url}zone/freshensuite/${devid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                                                })
                                                    .then((res) => {
                                                        if (res.Code == 0) {
                                                            if (parentIndex != undefined) {
                                                                this.suites[parentIndex].Briefs[index].Stay = false;
                                                            }
                                                            this.roomDetail.Stay = false;
                                                            this.$message('已成功退房');
                                                        } else {
                                                            this.$message(res.Message);
                                                        }
                                                    })
                                            } else {
                                                this.$message(res.Message);
                                            }
                                        })
                                } else {
                                    this.$message(res.Message);
                                }
                            })
                    })
            },
            powerRecords(devid) {
                this.allPower = 0;
                this.allApportion = 0;
                this.powerRecordsVisible = true;
                store.commit('assignClickDevid', devid);

                let start = new Date();
                let end = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                end.setTime(end.getTime() + 3600 * 1000 * 24)
                this.powerRecordsBdate = store.getters.getNowFormatDate(start);
                this.powerRecordsEdate = store.getters.getNowFormatDate(end);
                this.powerRecordsValue1 = this.powerRecordsBdate;
                this.powerRecordsValue2 = this.powerRecordsEdate;

                let arr = [];
                this.$http.get(`${store.state.url}device/ammeter/report/${devid}/${this.powerRecordsBdate}/${this.powerRecordsEdate}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            res.Data.forEach((item, index) => {
                                let obj = {};
                                obj.date = item.Date;
                                obj.power = item.Allpower.toFixed(2);
                                obj.apportion = item.Apportion.toFixed(2);
                                arr.push(obj);
                                this.allPower += item.Allpower;
                                this.allApportion += item.Apportion;
                            });
                            console.log( arr);
                            this.powerRecordsArr = arr;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            changePowerRecordsDate() {
                let devid = store.state.clickDevid,
                    arr = [];
                if (this.powerRecordsValue1 != '' && this.powerRecordsValue2 != '') {
                    this.$http.get(`${store.state.url}device/ammeter/report/${devid}/${this.powerRecordsValue1}/${this.powerRecordsValue2}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.allPower = 0;
                                this.allApportion = 0;
                                res.Data.forEach((item, index) => {
                                    let obj = {};
                                    obj.date = item.Date;
                                    obj.power = item.Allpower.toFixed(2);
                                    obj.apportion = item.Apportion.toFixed(2);
                                    arr.push(obj);
                                    this.allPower += item.Allpower;
                                    this.allApportion += item.Apportion;
                                });
                                this.powerRecordsArr = arr;
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }
            },
            getRechargeRecords(devid) {
                this.rechargeRecordsVisible = true;
                store.commit('assignClickDevid', devid);

                let start = new Date();
                let end = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                end.setTime(end.getTime() + 3600 * 1000 * 24)
                this.rechargeRecordsBdate = store.getters.getNowFormatDate(start);
                this.rechargeRecordsEdate = store.getters.getNowFormatDate(end);

                this.rechargeRecordsValue1 = this.rechargeRecordsBdate;
                this.rechargeRecordsValue2 = this.rechargeRecordsEdate;
                let arr = [];
                this.$http.get(`${store.state.url}account/recharge/${store.state.clickDevid}/${this.rechargeRecordsBdate}/${this.rechargeRecordsEdate}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            res.Data.forEach((item, index) => {
                                let obj = {};
                                obj.date = item.Addtime.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, "");
                                obj.money = item.Money.toFixed(2);
                                obj.name = item.Name;
                                obj.phone = item.Phone;
                                if (item.Rechargeway == 0) {
                                    obj.rechargeway = '线下';
                                } else if (item.Rechargeway == 1) {
                                    obj.rechargeway = '微信';
                                } else if (item.Rechargeway == 2) {
                                    obj.rechargeway = '支付宝';
                                } else {
                                    obj.rechargeway = '民生';
                                }
                                obj.cause = item.Cause;
                                arr.push(obj);
                            });
                            this.rechargeRecords = arr;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            changeRechargeRecords() {
                if (this.value1 != '' && this.value2 != '') {
                    let arr = [];
                    this.$http.get(`${store.state.url}account/recharge/${store.state.clickDevid}/${this.rechargeRecordsBdate}/${this.rechargeRecordsEdate}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                res.Data.forEach((item, index) => {
                                    let obj = {};
                                    obj.date = item.Date;
                                    obj.money = item.Price.toFixed(2);
                                    obj.name = item.Name;
                                    obj.phone = item.Phone;
                                    if (item.Rechargeway == 0) {
                                        obj.rechargeway = '线下';
                                    } else if (item.Rechargeway == 1) {
                                        obj.rechargeway = '微信';
                                    } else if (item.Rechargeway == 2) {
                                        obj.rechargeway = '支付宝';
                                    } else {
                                        obj.rechargeway = '民生';
                                    }
                                    obj.cause = item.Cause;
                                    arr.push(obj);
                                });
                                this.rechargeRecords = arr;
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }
            },
            getCheckinRecords(devid) {
                this.checkinRecordsVisible = true;
                store.commit('assignClickDevid', devid);

                let start = new Date();
                let end = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                end.setTime(end.getTime() + 3600 * 1000 * 24)
                this.checkinRecordsBdate = store.getters.getNowFormatDate(start);
                this.checkinRecordsEdate = store.getters.getNowFormatDate(end);

                this.checkinRecordsValue1 = this.checkinRecordsBdate;
                this.checkinRecordsValue2 = this.checkinRecordsEdate;

                this.$http.get(`${store.state.url}device/ammeter/room/${store.state.clickDevid}/${this.checkinRecordsBdate}/${this.checkinRecordsEdate}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            if (res.Data == null) {
                                this.checkinRecords = [];
                            } else {
                                this.checkinRecords = res.Data;
                            }
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            changeCheckinRecords() {
                if (this.value1 != '' && this.value2 != '') {
                    this.$http.get(`${store.state.url}device/ammeter/room/${store.state.clickDevid}/${this.checkinRecordsValue1}/${this.checkinRecordsValue2}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                if (res.Data == null) {
                                    this.checkinRecords = [];
                                } else {
                                    this.checkinRecords = res.Data;
                                }
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }
            },
            showOrHideAccountList() {
                this.clickCount++;
                if (this.clickCount % 2 == 0) {
                    this.showAccount = false
                } else {
                    this.showAccount = true
                }
            },
            changeRoomTitle() {
                this.isShowRoomTitle = false;
            },
            confirmChangeRoomTitle(devid, title) {
                this.$http({
                    method: 'put',
                    url: `${store.state.url}device?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: {
                        Uuid: devid,
                        Title: title,
                    }
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.$http({
                                method: 'get',
                                url: `${store.state.url}zone/freshensuite/${devid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                            })
                                .then((res) => {
                                    if (res.Code == 0) {
                                        this.roomDetail.Title = title;
                                        this.suites[this.parentIndexPre].Briefs[this.indexPre].Title = title;
                                    } else {
                                        this.$message(res.Message);
                                    }
                                })
                        } else {
                            this.$message(res.Message);
                        }
                    })

                this.isShowRoomTitle = true;
            },
            getOperateRecords(devid) {
                this.oprateRecordIndex = 0;
                store.commit('assignClickDevid', devid);
                let pageIndex = 0,
                    pageSize = 50;

                this.$http.get(`${store.state.url}logger/paging/${devid}/${pageIndex}/${pageSize}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.oprateRecordsVisible = true;
                            if (res.Data == null) {
                                this.oprateRecords = [];
                            } else {
                                this.oprateRecords = res.Data;
                                if (this.oprateRecords.length < 50) {
                                    this.isShowOprateArrow = false;
                                } else {
                                    this.isShowOprateArrow = true;
                                }
                            }
                            console.log(this.oprateRecords)
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },


            downloadOprateRecords () {
                this.oprateRecordsVisible = false
                const defaultCellStyle =  { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};
                const wopts = { bookType:'xlsx', bookSST:false, type:'binary', defaultCellStyle: defaultCellStyle, showGridLines: false};
                const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };

                let Data=[];
                for(let i in this.oprateRecords){
                    Data[i] = {
                        操作内容: this.oprateRecords[i].Content,
                        操作时间: this.oprateRecords[i].Addtime.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, ""),
                    };
                }
                let data = Data;
                wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                //创建二进制对象写入转换好的字节流
                let tmpDown =  new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" });
                FileSaver.saveAs(tmpDown, "充值记录.xls");
            },
            downloadPowerRecords() {
                this.powerRecordsVisible = false;
                const defaultCellStyle =  { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};
                const wopts = { bookType:'xlsx', bookSST:false, type:'binary', defaultCellStyle: defaultCellStyle, showGridLines: false};
                const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };

                let Data=[];
                for(let i in this.powerRecordsArr){
                    Data[i] = {
                        日期: this.powerRecordsArr[i].date,
                        电量: this.powerRecordsArr[i].power,
                        公摊: this.powerRecordsArr[i].apportion,
                    };
                }
                let data = Data;
                wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                //创建二进制对象写入转换好的字节流
                let tmpDown =  new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" })
                FileSaver.saveAs(tmpDown, "用电记录.xls");
            },
            downloadCheckinRecords() {
                this.checkinRecordsVisible = false;
                const defaultCellStyle =  { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};
                const wopts = { bookType:'xlsx', bookSST:false, type:'binary', defaultCellStyle: defaultCellStyle, showGridLines: false};
                const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };

                let Data=[];
                for(let i in this.checkinRecords){
                    if (this.checkinRecords[i].Expand != null) {
                        Data[i] = {
                            入住日期: this.checkinRecords[i].Expand.checkindate,
                            退房日期: this.checkinRecords[i].Addtime.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, "").replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/,""),
                            租客:     this.checkinRecords[i].Expand.name,
                            初始电量: this.checkinRecords[i].Initpower.toFixed(2),
                            退房电量: this.checkinRecords[i].Lastpower.toFixed(2),
                            总耗电量: this.checkinRecords[i].Allpower.toFixed(2),
                            分摊电量: this.checkinRecords[i].Apportion.toFixed(2),
                            计费电量: this.checkinRecords[i].Allpower.toFixed(2),
                            电费单价: this.checkinRecords[i].Price,
                        }
                    } else {
                        Data[i] = {
                            退房日期: this.checkinRecords[i].Addtime.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, "").replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/,""),
                            初始电量: this.checkinRecords[i].Initpower.toFixed(2),
                            退房电量: this.checkinRecords[i].Lastpower.toFixed(2),
                            总耗电量: this.checkinRecords[i].Allpower.toFixed(2),
                            分摊电量: this.checkinRecords[i].Apportion.toFixed(2),
                            计费电量: this.checkinRecords[i].Allpower.toFixed(2),
                            电费单价: this.checkinRecords[i].Price,
                        }
                    }
                }
                let data = Data;
                wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                //创建二进制对象写入转换好的字节流
                let tmpDown =  new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" })
                FileSaver.saveAs(tmpDown, "入住记录.xls");
            },
            //字符串转字符流
            s2ab (s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },
            showCommunityForm() {
                this.isShowCommunityForm = !this.isShowCommunityForm;
            },
            showLevel1HouseForm() {
                this.isShowLevel1HouseForm = !this.isShowLevel1HouseForm;
            },
            showLevel2HouseForm() {
                this.isShowLevel2HouseForm = !this.isShowLevel2HouseForm;
            },
            showHouseForm() {
                this.isShowHouseForm = !this.isShowHouseForm;
            },
            selectMode(val) {
                this.modeValue = val;
            },
            selectAlarmVal(val) {
                this.alarmValue = val;
            },
            selectCommunity(val) {
                this.communityCode = val;
                console.log(val)
                this.$http.get(`${store.state.url}house/select/${val}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.level1Houses = res.Data;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            selectLevel1House(val) {
                this.$http.get(`${store.state.url}house/select/${this.communityCode}/${val}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            this.level2Houses = res.Data;
                            this.houseCode = res.Data.Code;
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            selectLevel2House(val) {
                this.houseCode = val;
            },
            loadOprateRecord() {
                this.oprateRecordIndex++;
                let pageIndex = this.oprateRecordIndex,
                    pageSize = 10,
                    devid = store.state.clickDevid;

                this.$http.get(`${store.state.url}logger/paging/${devid}/${pageIndex}/${pageSize}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            if (res.Data != null) {
                                this.oprateRecordsVisible = true;
                                this.oprateRecords = this.oprateRecords.concat(res.Data);
                                if (this.suites.length % 10 != 0) {
                                    this.isShowOprateArrow = false;
                                } else {
                                    this.isShowOprateArrow = true;
                                }
                            } else {
                                this.$message('已加载完毕');
                            }
                        } else {
                            this.$message(res.Message);
                        }
                    })
            },
            loadHouse() {
                let skip = this.houseSkip,
                    limit = 10,
                    zoneid = this.zone.Uuid;

                this.$http.get(`${store.state.url}zone/suiteview/${zoneid}/${skip}/${limit}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            if (res.Data != null) {
                                this.loadSuitLen = res.Data.length;
                                this.suites = this.suites.concat(res.Data);
                                if (this.levelSuite.SumSuite <= this.suites.length) {
                                    this.isShowArrow = false;
                                } else {
                                    this.isShowArrow = true;
                                }
                                console.log(this.levelSuite.SumSuite, this.suites.length)
                            } else {
                                this.$message('已加载完毕');
                            }
                        } else {
                            this.$message(res.Message);
                        }
                    })
                this.houseSkip += limit;
            },
            changeMode() {
                this.changeModeVisible = true;
            },
            confirmChangeMode() {
                if (this.roomDetail.PayMode == 0) {
                    this.$http({
                        method: 'put',
                        url: `${store.state.url}device/ammeter/paymode/${this.roomDetail.Devid}/1?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    })
                        .then((res) => {
                            this.$message(res.Message);
                            if (res.Code == 0) {
                                this.roomDetail.PayMode = 1;
                                this.changeModeVisible =false;
                            }
                        })
                } else {
                    this.$http({
                        method: 'put',
                        url: `${store.state.url}device/ammeter/paymode/${this.roomDetail.Devid}/0?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    })
                        .then((res) => {
                            this.$message(res.Message);
                            if (res.Code == 0) {
                                this.roomDetail.PayMode = 0;
                                this.changeModeVisible =false;
                            }
                        })
                }
            },
            returnTable() {
                if (store.state.preTable == 0) {
                    this.$router.push('/abnormal');
                    store.commit('assignAbnormalTableTabIndex', store.state.preAbnormalTabIndex);
                } else if (store.state.preTable == 1) {
                    this.$router.push('/report');
                    store.commit('assignReportTableTabIndex', store.state.preReportTabIndex);
                }
            },
            // showAddHouseForm(suite) {
            //     store.commit('assignDeleteHid', hid);
            //     this.$http.get(`${store.state.url}house/city/3/${code}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
            //         .then((res) => {
            //             if (res.Code == 0) {
            //                 this.citys3 = res.Data;
            //                 this.community = "";
            //                 this.selectedDistrict = code;
            //             } else {
            //                 this.$message(res.Message);
            //             }
            //         })
            // },
        }
    }
</script>

<style scoped>
    .house-content, .house-tab {
        height: 100%;
    }
    .house-left, .house-right {
        width: 15vw;
        height: 100%;
        /*min-width: 15vw;*/
    }
    .house-left {
        border: 1px solid #999;
        border-left: 0;
        border-bottom: 0;
        /*overflow: auto;*/
    }
    .house-left-tree{
        margin:0.1rem 1px 0.1rem 0;
        height:93%;
        overflow: auto;
    }
    .house-left .house-content {
        padding-left: 0.1rem;
    }
    .house-left .add-house {
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        padding-left: 0.1rem;
        font-size: 0.16rem;
        border-bottom: 1px solid #999;
        height: 0.39rem;
        cursor: pointer;
    }
    .house-left .add-house i {
        color: #F56C6C;
        margin-right: 0.06rem;
    }
    .house-left .add-house:hover{
        color: #F56C6C;
    }
    .house-panel {
        display: flex;
        flex-direction: row;
        justify-content: left;
        height: 100%;
    }
    .house-right .right-room-info {
        height: 100%;
    }
    .house-mid {
        width: 70%;
        height: 94%;
        padding: 0 0 0.1rem 0.1rem;
        border-top: 1px solid #999;
    }
    .house-mid .house-addr {
        height: 0.39rem;
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0.16rem;
        margin-bottom: 0.1rem;
        border-bottom: 1px solid #999;
        margin-left: -0.1rem;
    }
    .house-mid .house-addr .house-addr-content {
        padding-left: 0.1rem;
    }
    .house-struct-items {
        overflow: auto;
        height: 99%;
        margin-right:1px;
    }
    .house-mid .house-items {
        display: flex;
        flex-direction: row;
        justify-content: left;
        flex-wrap: wrap;
        margin-bottom: 0.1rem;
    }
    .house-right .room-info, .house-right .room-info .el-tabs {
        height: 100%;
    }
    .house-right .room-info .el-tabs--border-card {
        border: 1px solid #999;
        border-bottom: 0;
    }
    .house-items .house-item {
        padding: 0.05rem;
        width: 1.7rem;
        box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);
        position: relative;
        margin-right: 1%;
        background: #fff;
        margin-left: 1%;
        margin-bottom: 0.1rem;
        cursor: pointer;
    }
    .house-struct-item {
        background: #f9f9f9;
        margin-bottom: 0.25rem;
        margin-right:1px;
    }
    .suite-title-content {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    }
    .suite-title-content .return-table {
        color: #388be0;
        margin-right: 2vh;
        cursor: pointer;
    }
    .house-struct-item .suite-title {
        margin-bottom: 0.02rem;
        font-size: 0.2rem;
        color: #3688da;
        padding-left: 1%;
        padding-top: 0.1rem;
        padding-bottom: 0.1rem;
        width: 70%;
    }
    .houseClick {
        border: 1px solid #409EFF;
    }
    .house-item .room-info {
        display: flex;
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: left;
        margin-bottom: 0.05rem;
        font-size: 0.13rem;
        color: #666;
    }
    .house-item .room-info .room-info-title {
        width: 45%;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap
    }
    .house-item .house-item-shade {
        /*display: none;*/
        background: #eeeeee;
        width: 100%;
        height: 100%;
        opacity: .6;
        position: absolute;
        z-index: 1000;
        top: 0;
        left: 0;
    }
    .shade .shade-info {
        display: flex;
        justify-content: left;
        padding-top: 0.05rem;
        padding-left: 0.05rem;
    }
    .triangle-in,.triangle-out  {
        width: 0;
        height: 0;
        border-top: 0.5rem solid rgba(64, 158, 255, 0.83);
        border-left: 0.5rem solid transparent;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1001;
    }
    .triangle-out{
        border-top: 0.5rem solid #409EFF;
    }
    .check-status-in, .check-status-out {
        position: absolute;
        top: 0.08rem;
        right: 0.03rem;
        color: #fff;
        font-size: 0.11rem;
        z-index: 1001;
    }
    .check-status-out {
        color: #fff;
    }
    .icons {
        /*position: absolute;*/
        /*bottom: 0;*/
        width: 100%;
        font-size: 0.25rem;
        display: flex;
        justify-content: space-around;
        margin-bottom: 0.05rem;
        margin-top: 0.1rem;
        z-index: 1001;
    }
    .icons i {
        margin-left: 0.05rem;
    }
    .info-detail {
        padding: 0.1rem;
        height: 100%;
        border: 1px solid #999;
        border-bottom: 0;
    }
    .house-info-detail {
        margin-bottom: 0.2rem;
    }
    .house-info-detail-button {
        display: flex;
        justify-content: center;
    }
    /*.house-info-detail-title {*/
        /*font-size: 0.18rem;*/
        /*color: #999;*/
        /*margin-bottom: 0.1rem;*/
        /*display: flex;*/
        /*justify-content: left;*/
    /*}*/
    .house-info-detail-title {
        font-size: 0.18rem;
        color: #388be0;
        margin-bottom: 0.1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.18rem;
    }
    .house-info-detail-title .dashed {
        /*border: 1px #000 dashed;*/
        width: 30%;
        height: 100%;
        display: flex;
        align-items: center;
    }
    .dashed-name {
        width: 40%;
        display: flex;
        justify-content: center;
        white-space: nowrap;
        font-size: 0.1vw;
    }
    .dashed .dashed-content {
        border: 1px #ddd dashed;
        width: 100%;
        height: 1px;
    }
    .house-info-detail-body {
        padding: 0.1rem;
        padding-left: 0;
        padding-top: 0;
        /*border: 1px solid #ddd;*/
        /*border-radius: 6px;*/
    }
    .house-detail-body-item {
        display: flex;
        flex-direction: row;
        justify-content: left;
        margin-bottom: 0.1rem;
    }
    .house-detail-body-item:last-child {
        margin-bottom: 0;
    }
    .room-detail-items {
        white-space: nowrap;
    }
    .room-detail-items .room-detail-item {
        display: flex;
        justify-content: left;
        align-items: flex-end;
        padding-left: 0.1rem;
        margin-bottom: 0.1rem;
    }
    .room-detail-icons {
        margin-top: 0.25rem;
        display: flex;
        justify-content: space-around;
    }
    .room-detail-icons i {
        font-size: 0.25rem;
    }

    /*::-webkit-scrollbar {!*滚动条整体样式*!*/
        /*width: 0px;     !*高宽分别对应横竖滚动条的尺寸*!*/
        /*height: 0px;*/
    /*}*/
    .room-devices i {
        margin-right: 0.05rem;
    }
    .room-title-input {
        height: 0.2rem;
        border: 1px solid #eee;
        width: 6.5vw;
        margin-right: 0.2vw;
        padding-left: 0.5vw;
        font-size: 0.7vw;
    }
    .room-title-name {
        margin-right: 0.1vw;
        font-size: 0.7vw;
    }
    .room-title-button {
        height: 0.2rem;
        width: 3vw;
        background: #409EFF;
        font-size: 0.1rem;
        color: #fff;
    }
    .checkin-item {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.2rem;
    }
    .checkin-item:last-child {
        margin-bottom: 0;
    }
    .checkin-input {
        width: 80%;
    }


    .checkin-records-item {
        box-shadow: 1px 1px 1px #ccc;
        margin-bottom: 0.1rem;
        padding: 0.1rem;
        width: 98%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .checkin-records-item-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 0.05rem;
    }
    .checkin-records-item-row div {
        width: 50%;
    }
    .checkin-records-block {
        margin-bottom: 0.1rem;
        display: flex;
        justify-content: center;
    }
    .checkin-records-block .block {
        width: 100%;
        display: flex;
        justify-content: space-around;
    }
    .checkin-records-block .block .date-picker {
        width: 40%;
    }
    .oprate-records-item-row {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 0.05rem;
    }
    .oprate-records-item-row div:first-child {
        margin-bottom: 0.1rem;
    }
    .add-house-select-title {
        margin-right: 0.5vw;
        white-space: nowrap;
    }
    .add-house-select:last-child {
        margin-right: 0;
    }
    .add-house-select {
        width: 37%;
        margin-right: 1%;
    }
    .add-house-button-select {
        margin-right: 3%;
        width: 70%;
    }
    .create_community_form {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 0.1rem;
    }
    .create_community_form .create_community_form_input {
        margin-bottom: 0.1rem;
        width: 90%;
    }
    .button-center{
        text-align: center;
        margin-bottom:0.15rem;
    }
    .create_community_form_button{
        width:100px;
    }
    .add-house-item {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    }
    .add-house-item>div {
        font-size: 0.8vw;
    }
    .flowe-meter-item {
        margin-bottom: 4vh;
    }
    .load-arrow {
        display: flex;
        justify-content: center;
        cursor: pointer;
        font-size: 2vh;
    }
    #pay-mode-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .change-mode {
        margin-right: 0%;
        background: #409EFF;
        height: 2.5vh;
        width: 3vw;
        font-size: 0.6vw;
        color: #fff;
    }
    button {
        cursor: pointer;
    }
    .recharge-money {
        margin-bottom: 0.05rem;
    }
    .recharge-num {
        padding-left: 0.8rem;
        margin-bottom: 0.1rem;
    }
    .power-statistic>div {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        margin-top: 1vh;
        font-size: 0.8vw;
    }
    .power-statistic .statistic-title {
        width: 3.5vw;
        display: flex;
        justify-content: flex-end;
    }
</style>
